import {
  manageSelectedPredeliveryPins,
  manageSelectedRelocatePins,
  setUnassociatedPinAnyData,
} from "../../../../../../../../features/senninha/routesManagementSlice";

// Fonte única da verdade das regras de seleção de pins no fluxo de realocação
// (workflow 'routesDrawer-relocation'). É usada tanto pelo clique no marker
// quanto pela seleção por área (retângulo/laço), garantindo comportamento
// idêntico: selecionar um pin pela área é equivalente a clicá-lo.
//
// Recebe:
// - dataPin: o pin sendo selecionado
// - state: store.getState() ATUAL (as regras dependem do estado acumulado,
//   então em seleção em lote releia o state a cada pin)
// - dispatch: o dispatch do Redux
export const applyRelocationSelection = ({ dataPin, state, dispatch }) => {
  // polo que só acompanha o pedido: o pin aparece no mapa, mas não entra na realocação
  if (dataPin.somente_visualizacao) return;

  const { pins } = state.pinsSlice;
  const { selectedRelocatePins } = state.routesManagementSlice;

  const matchesColetaEntrega = (coleta, entrega) => {
    if (coleta.associatedPinsIDs?.includes(entrega.id)) return true;
    if (!coleta.id_atendimento || !entrega.id_atendimento) return false;
    return Array.isArray(entrega.id_atendimento)
      ? entrega.id_atendimento.some((id) => coleta.id_atendimento.includes(id))
      : coleta.id_atendimento.includes(entrega.id_atendimento);
  };

  const selectedCollectPins = pins.filter(
    (item) =>
      item.servico?.toLowerCase() === "coleta" &&
      selectedRelocatePins.find((item2) => item2.id === item.id)
  );
  const collectPinsUnallocated = selectedCollectPins.filter(
    (coleta) =>
      !selectedRelocatePins.some(
        (item) => item.id !== coleta.id && matchesColetaEntrega(coleta, item)
      )
  );

  // regras auxiliares
  const hasNoSelectedPins = !selectedRelocatePins.length;
  const hasUnallocatedCollectPin =
    !!collectPinsUnallocated.length && selectedCollectPins.length;
  const clickedPinAlreadySelected = !!selectedRelocatePins.find(
    (item) => item.id === dataPin.id
  );
  const clickedAdqPin = dataPin.tipo?.toLowerCase() !== "any";
  const clickedCollectPin = dataPin.servico?.toLowerCase() === "coleta";
  const clickedDeliveryPin = dataPin.servico?.toLowerCase() === "entrega";
  const associatedWithCollectPin = !!selectedCollectPins.find((coleta) =>
    matchesColetaEntrega(coleta, dataPin)
  );

  // regras pins adq
  const allowSelectAdqPin = clickedAdqPin && !hasUnallocatedCollectPin;

  // regras pins coleta
  const hasUnallocatedCollectPinAndClickedCollect =
    clickedCollectPin && !hasUnallocatedCollectPin;

  // regras pins entrega
  const isDeliveryPinFromUnallocatedCollectPin =
    clickedDeliveryPin && hasUnallocatedCollectPin && associatedWithCollectPin;
  const hasUnallocatedDeliveryPinAndClickedDelivery =
    clickedDeliveryPin && !hasUnallocatedCollectPin;
  const shouldSelectCollectPinAssociated =
    clickedDeliveryPin &&
    !clickedPinAlreadySelected &&
    !associatedWithCollectPin;

  if (
    hasNoSelectedPins ||
    allowSelectAdqPin ||
    hasUnallocatedCollectPinAndClickedCollect ||
    isDeliveryPinFromUnallocatedCollectPin ||
    hasUnallocatedDeliveryPinAndClickedDelivery ||
    (clickedPinAlreadySelected && !clickedAdqPin)
  ) {
    if (clickedAdqPin) {
      dispatch(manageSelectedPredeliveryPins(dataPin));
      dispatch(setUnassociatedPinAnyData({}));
    }

    dispatch(manageSelectedRelocatePins(dataPin));

    if (clickedCollectPin && !clickedPinAlreadySelected) {
      dispatch(
        setUnassociatedPinAnyData({
          unassociatedPin: dataPin,
          deliveriesPins2BeAssociated: pins.filter(
            (item) =>
              item.servico === "ENTREGA" &&
              item.id_atendimento &&
              (Array.isArray(item.id_atendimento)
                ? item.id_atendimento.some((id) =>
                    dataPin?.id_atendimento?.includes(id)
                  )
                : dataPin?.id_atendimento?.includes(item.id_atendimento))
          ),
        })
      );
    }

    if (shouldSelectCollectPinAssociated) {
      const associatedCollectPin2BeSelected = pins.find((item) =>
        item?.associatedPinsIDs?.includes(dataPin.id)
      );
      if (associatedCollectPin2BeSelected) {
        dispatch(manageSelectedRelocatePins(associatedCollectPin2BeSelected));
        dispatch(
          setUnassociatedPinAnyData({
            unassociatedPin: associatedCollectPin2BeSelected,
            deliveriesPins2BeAssociated: pins.filter((item) =>
              associatedCollectPin2BeSelected?.associatedPinsIDs.includes(
                item.id
              )
            ),
          })
        );
      }
    }
  }
};
